import { Component, Input, OnInit } from '@angular/core';
import { AppCmsUrlsInitializationService } from 'src/app/services/app-cms-urls-initialization.service';
import { ApplicationInitializationService } from 'src/app/services/application-initialization.service';
import { CmsContentService } from 'src/app/services/cms-content.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';

@Component({
  selector: 'app-cfm-faq',
  templateUrl: './cfm-faq.component.html',
  styleUrls: ['./cfm-faq.component.scss']
})

export class CfmFaqComponent implements OnInit {
  @Input() cmsContentId?: string;
  cmsUrlCode: string;
  data:any;
  constructor(private APPCMSIS: AppCmsUrlsInitializationService, 
    private APPIS: ApplicationInitializationService,
    private CCS:CmsContentService,
    private UTS: UtilitiesService,
    ) {

  }

  ngOnInit(): void {
    this.init()
  }

  init() {
    this.cmsUrlCode = this.cmsContentId;
    let CMS_URLS = this.APPCMSIS.appInitializer.CMS_URLS;
    let CMS_URL = null;
    let url = null;
    if (CMS_URLS && CMS_URLS.length > 0) {
      CMS_URL = CMS_URLS.find((c) => c?.cmsUrlCode == this.cmsUrlCode);
      url =
        this.APPIS.environmentConfig.CMS_URL_NEW_FRAGMENTPATH + CMS_URL?.cmsUrlEn;
    }
    if (this.UTS.getLocaleLanguage() == 'ar')
      url =
        this.APPIS.environmentConfig.CMS_URL_NEW_FRAGMENTPATH +
        CMS_URL?.cmsUrlAr;
    this.CCS.newFragemnetContentService(url).subscribe(
      (result: any) => {
        this.data = result?.data?.bauMainSectionByPath?.item;
      },
      (error) => {
      }
    );
  }

}

